import { Component } from "react";

import { InputField } from "@bokio/designsystem/components/Form/InputField";

import type { UnTypedInputFieldProps } from "./InputField";

// NOTE: MQ 2020-05-12 onChange's value should be number but it is string now
interface NumberFieldProps extends UnTypedInputFieldProps {
	min?: number;
	max?: number;
	step?: number;
}

export class NumberField extends Component<NumberFieldProps> {
	render() {
		const props: UnTypedInputFieldProps = {
			...this.props, // NE 2018-05-28 issue here: The min, max, step props are spread to the InputField which dont have those attributes.
			fieldProps: {
				...this.props.fieldProps,
				type: "number",
				min: this.props.min,
				max: this.props.max,
				step: this.props.step || 1,
				inputMode: "numeric",
			},
		};

		return <InputField {...props} />;
	}
}
